import { get, post } from '@/lib/api';
import type { SubStatus } from './profile';

export type PaymentStatus = 'PENDING' | 'SUCCEEDED' | 'FAILED' | 'REFUNDED';

export interface BillingPayment {
  id: string;
  amount: number; // копейки
  currency: string;
  status: PaymentStatus;
  method: string | null;
  failureReason: string | null;
  paidAt: string | null;
  createdAt: string;
}

export interface BillingInfo {
  status: SubStatus;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  priceKop: number;
  hasPaymentMethod: boolean;
  autoRenew: boolean;
  cancelledAt: string | null;
  billingEnabled: boolean;
  payments: BillingPayment[];
}

export interface CheckoutResult {
  paymentId: string;
  confirmationUrl: string;
  amountKop: number;
}

export const getBilling = () => get<BillingInfo>('/billing');

export const checkout = (returnUrl?: string) =>
  post<CheckoutResult>('/billing/checkout', { returnUrl });

export const cancelSubscription = (reason?: string) =>
  post<{ ok: true }>('/billing/cancel', { reason });
